import {AdminService} from "@/services/admin-service.ts";
import {ExamService} from "@/services/exam-service.ts";
import {LessonService} from "@/services/lesson-service.ts";
import {EmailAuthService} from "@/services/email-auth.service.ts";
import {UserService} from "@/services/user-service.ts";
import {PaymentService} from "@/services/payments-service.ts";
import {GroupsService} from "@/services/groups-service.ts";


export class Api {
  auth = EmailAuthService.getInstance()
  admin = AdminService.getInstance();
  users = UserService.getInstance()
  exams = ExamService.getInstance();
  lessons = LessonService.getInstance();
  payments = PaymentService.getInstance();
  groups = GroupsService.getInstance();
}

export const api = new Api;